import dayjs from 'dayjs';

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '₹0';
  return '₹' + Number(amount).toLocaleString('en-IN');
};

export const formatDate = (date) => {
  if (!date) return '-';
  return dayjs(date).format('DD MMM YYYY');
};

export const profitColor = (val) => (Number(val) >= 0 ? '#52c41a' : '#ff4d4f');

const colors = { success: '#4ebf53', danger: '#D8583D' };

export const getPaymentStatusColor = (status) => {
  if (status === 'paid' || status === 'credit') return colors.success;
  if (status === 'partial') return '#fa8c16';
  if (status === 'na') return '#9ca3af';
  return colors.danger;
};

// For interpolating free-text values (names, notes, etc.) into a print/PDF HTML
// template — without this, a name/note containing `<`/`>`/`&`/`"` can break the
// table markup it's inserted into.
export const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
